<template>
    <component :is="layout">
        <router-view />
    </component>
</template>
  
<script>
import Marketing from '@/views/marketing/Marketing.vue'
import FinancialControl from '@/views/financialControl/index.vue'
import Direktur from '@/views/direktur/index.vue'
import Default from '@/views/layouts/default.vue'

export default {
    components: {
        Marketing,
        FinancialControl,
        Direktur,
        Default
    },

    computed: {
        layout() {
            const slug = this.$route.params.slug

            switch (slug) {
                case 'marketing':
                    return 'Marketing'
                case 'financialControl':
                    return 'FinancialControl'
                case 'direktur':
                    return 'Direktur'
                default:
                    return 'Default'
            }
        }
    }
}
</script>